import { connect } from 'react-redux'
import { getInvestments } from 'services/user'
import Navigation from 'support/navigation'
import View from './View'
import { getInnovateChallengeActiveTypes, getInnovateChallengeAllList } from 'services/innovate/challenge'

const mapStateToProps = state => {
  return {
    ideas: state.data.user.investments.ideas,
    userEmail: state.data.user.userEmail,
    isAdmin: state.data.user.admin,
    listInnovateChallenge:state.data.InnovateChallenge.listInnovateChallenge,
    innovateCategoryTypes:state.data.InnovateChallenge.innovateCategoryTypes,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getInnovateChallengeAllListFn: () => {
      dispatch(getInnovateChallengeAllList())
    },
    getInnovateChallengeActiveTypesFn: () => {
      dispatch(getInnovateChallengeActiveTypes())
    },
    onEditClick: id => {
      dispatch(Navigation.navigateToInnovateChallengeForm(id))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View)
